function parseOrUndefined(value) {
    try {
        return JSON.parse(value);
    }
    catch {
        return undefined;
    }
}
export function serialize(search) {
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(search)) {
        searchParams.append(key, JSON.stringify(value));
    }
    return searchParams;
}
export function deserialize(search) {
    const params = new URLSearchParams(search);
    const result = {};
    for (const [key, value] of params) {
        const parsedValue = parseOrUndefined(value);
        if (parsedValue === undefined) {
            continue;
        }
        result[key] = parsedValue;
    }
    return result;
}
